import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import { TemplateDataTable } from "./TemplateDataTable";
import { HOST_URL } from "../api/Api";
import Axios from "../../../axios/Axios";
import styles from "./EmailTemplateNew.module.css";

const EmailTemplate = () => {
  const login = JSON.parse(localStorage.getItem("login"));
  const userId = login?.user?.userId;
  const token = login?.token;

  /* FETCH DATA */
  const fetchEmailTemplates = useCallback(
    async ({ page, limit, search }) => {
      const payload = {
        user_id: userId,
        method: search ? "search" : "retrieve",
        keyword: search || null,
        token,
      };

      const response = await Axios.post(
        `${HOST_URL}/email_template.php`,
        payload
      );

      if (!response?.data?.success) {
        return { data: [], total: 0 };
      }

      const rows = response.data.data || [];
      const start = (page - 1) * limit;

      return {
        data: rows.slice(start, start + limit),
        total: rows.length,
      };
    },
    [userId, token]
  );

  /* COLUMNS = EXACT OLD STRUCTURE */
  const emailColumns = [
    {
      key: "id",
      label: "MID",
      width: "90px",
      className: styles.cell,
      render: (row) => row.id,
    },
    {
      key: "template_name",
      label: "Name",
      width: "200px",
      className: styles.cell,
      render: (row) => (
    <div className={styles.wrapText}>
      {row.template_name}
    </div>
  ),
    },
    {
      key: "from_email",
      label: "From Email",
      width: "200px",
      className: styles.cell,
      render: (row) => row.from_email,
    },
{
  key: "content",
  label: "Email Content",
  width: "180px",
  className: styles.cell,
  render: (row, i) => (
    <div className={styles.tooltipWrap}>
      Message
      <span
        data-tip
        data-for={`emailTip-${row.id}`}
        className={styles.infoIcon}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </span>

      <ReactTooltip
        id={`emailTip-${row.id}`}
        place="bottom"
        effect="solid"
        className={styles.tooltip}
        html={true}
      >
        {row.content}
      </ReactTooltip>
    </div>
  ),
},


    {
      key: "is_active",
      label: "Status",
      width: "140px",
      className: styles.cell,
      render: (row) =>
        row.is_active === 1 ? (
          <span className={`${styles.status} ${styles.active}`}>
            Active
          </span>
        ) : (
          <span className={`${styles.status} ${styles.inactive}`}>
            Inactive
          </span>
        ),
    },
    {
      key: "created",
      label: "Create Date",
      width: "160px",
      className: styles.cell,
      render: (row) => row.created,
    },
    {
      key: "action",
      label: "Action",
      width: "100px",
      className: styles.cell,
      render: (row) => (
        <Link to={`/dashboard/email-template/edit/${row.id}`}>
          <span className={styles.editBtn}>
            <FontAwesomeIcon icon={faEdit} />
          </span>
        </Link>
      ),
    },
  ];

  return (
    <TemplateDataTable
      columns={emailColumns}
      fetchData={fetchEmailTemplates}
      pageSize={5}
      flags={{ search: true, pagination: true }}
      searchPlaceholder="Search Email templates"
    />
  );
};

export default EmailTemplate;
